import qs from 'qs'
import axios from '../index'
/**
 * @description 商品详情页
 * @author cc
 * @date 2020-07-22
 * @export
 */
export function loadDetailInfo (params) {
  return axios.post('/product/load-detail-info', qs.stringify(params))
}
/**
 * @description 商品留言
 * @author cc
 * @date 2020-07-24
 * @export
 */
export function addProposal (params) {
  return axios.post('/product/add-proposal', qs.stringify(params))
}
/**
 * @description 加载关联满赠商品
 * @author cc
 * @date 2020-07-24
 * @export
 */
export function loadGifts (params) {
  return axios.post('/product/load-gifts', qs.stringify(params))
}
/**
 * @description 加载关联满赠商品
 * @author cc
 * @date 2020-07-24
 * @export
 */
export function recommendGoods (params) {
  return axios.post('/product/recommend-goods', qs.stringify(params))
}
/**
 * @description 加载关联满赠商品
 * @author cc
 * @date 2020-07-24
 * @export
 */
export function getcouponGet (params) {
  return axios.post('/getcoupon/get', qs.stringify(params))
}
/**
 * @description 商品单个收藏
 * @author cc
 * @date 2020-08-06
 * @export
 */
export function Addfavone (params) {
  return axios.post('/user/add-fav-one', qs.stringify(params))
}
